import colors from 'styles/colors'

const meta = {
  itemColumn: {
    fontFamily: 'Barlow',
    background: '#FFF',
    boxShadow: '0 5px 10px 0 rgba(0,0,0,0.06)',
    borderRadius: 4,
    height: '100%',
    padding: 22,
    paddingBottom: 0,
    color: '#4A4A4A',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  itemName: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: 0.23,
    marginTop: 20,
    marginBottom: 10
  },
  subtitle: {
    fontSize: 12
  },
  itemFooter: {
    height: 40,
    marginTop: 40
  },
  itemView: {
    fontWeight: 500,
    color: colors.primary,
    fontSize: 12,
    margin: '10px 0',
    cursor: 'pointer',
    display: 'inline-block'
  },
  divider: {
    height: 1,
    background: '#E7E7E7',
    margin: '0 -22px'
  }
}

export default meta
